import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";


// const channelLogos = {
//   // she.com
//   beauty: "/assets-2021/img/nav-category-beauty.svg",
//   fashion: "/assets-2021/img/nav-category-fashion.svg",
//   entertainment: "/assets-2021/img/nav-category-entertainment.svg",
//   hair: "/assets-2021/img/nav-category-hair.svg",
//   health: "/assets-2021/img/nav-category-health.svg",
//   living: "/assets-2021/img/nav-category-living.svg",
//   love: "/assets-2021/img/nav-category-love.svg",
//
//   // shemom.com
//   babygrowth: '', // to be shown as text
//   babymetabolism: '', // to be shown as text
//   'celeb-family': '', // to be shown as text
//   'fashion-and-beauty': '', // to be shown as text
//   'hot-topics': '', // to be shown as text
//   lifestyle: '', // to be shown as text
//   motherhood: '', // to be shown as text
//   nestlemomme: '', // to be shown as text
//   'she-promotes': '', // to be shown as text
//
//   // brides.she.com
//   celeb: '', // to be shown as text
//   guides: '', // to be shown as text
//   'secret-talk-2': '', // to be shown as text
//   'style-beauty': '', // to be shown as text
//   tools: '', // to be shown as text
//   'wife-able': '', // to be shown as text
//   'utility-list': '', // to be shown as text
// };

const channelLogos = {
  'she.com': {
    beauty: "/assets-2021/img/nav-category-beauty.svg",
    fashion: "/assets-2021/img/nav-category-fashion.svg",
    entertainment: "/assets-2021/img/nav-category-entertainment.svg",
    hair: "/assets-2021/img/nav-category-hair.svg",
    health: "/assets-2021/img/nav-category-health.svg",
    living: "/assets-2021/img/nav-category-living.svg",
    love: "/assets-2021/img/nav-category-love.svg",
    instagram: '/assets-2021/img/instagram.svg',
  },
  'shemom.com': {
    babygrowth: '', // to be shown as text
    babymetabolism: '', // to be shown as text
    'celeb-family': '', // to be shown as text
    'fashion-and-beauty': '', // to be shown as text
    'hot-topics': '', // to be shown as text
    lifestyle: '', // to be shown as text
    motherhood: '', // to be shown as text
    nestlemomme: '', // to be shown as text
    'she-promotes': '', // to be shown as text
    health: '',
    instagram: '/assets-2021/img/instagram.svg',
  },
  'brides.she.com': {
    celeb: '', // to be shown as text
    guides: '', // to be shown as text
    'secret-talk-2': '', // to be shown as text
    'style-beauty': '', // to be shown as text
    tools: '', // to be shown as text
    'wife-able': '', // to be shown as text
    'utility-list': '', // to be shown as text
    instagram: '/assets-2021/img/instagram.svg',
  },
};



function getChannelLogo (theme, catSlug) {
  const themeLogos = channelLogos[theme];
  if (typeof themeLogos === 'undefined') { return null; }
  return typeof themeLogos[catSlug] !== 'undefined' ? themeLogos[catSlug] : null;
}

export default class Nav extends React.PureComponent {
  constructor () {
    super();

    this.state = {

      /**
       * State of where the scrolling position is
       */
      scrollTop: 0,

      /**
       * State of the last vertical scrolling directing if it is/was going up.
       */
      scrollingUp: false,

      /**
       * `false` when:
       *   - The page is just being loaded and user hasn't scrolled yet.
       *   - User scroll the page but he hasn't scrolled back to top yet.
       * `true` if:
       *   - User has scrolled back to top at least once, no matter where the
       *     scrolling position is currently.
       *
       * NOTE : once it becomes `true`, it will always be.
       */
      hitTop: false,
    };

    this.rootRef = React.createRef();

    this.onWindowSroll = this.onWindowSroll.bind(this);
    this.onSearchCloseClick = this.onSearchCloseClick.bind(this);
    this.onMagnifierClick = this.onMagnifierClick.bind(this);
    this.onBurgerClick = this.onBurgerClick.bind(this);
  }

  componentDidMount () {
    window.addEventListener("scroll", this.onWindowSroll);
    this.onWindowSroll();

    [...document.getElementsByClassName('search-btn-close')].forEach(closeButton => {
      closeButton.addEventListener('click', this.onSearchCloseClick);
    });
  }

  componentWillUnmount () {
    window.removeEventListener("scroll", this.onWindowSroll);

    [...document.getElementsByClassName('search-btn-close')].forEach(closeButton => {
      closeButton.removeEventListener('click', this.onSearchCloseClick);
    });
  }

  onWindowSroll () {
    this.setState(prevState => {
      const scrollTop = document.documentElement.scrollTop;
      const newState = {
        scrollTop,
        scrollingUp: scrollTop < prevState.scrollTop,
      };
      if (!prevState.hitTop) {
        newState.hitTop = scrollTop === 0 && newState.scrollingUp;
      }
      if(window.innerWidth >=600){
        if(document.getElementById('atFrame_SkinTop') !=null){
          console.log('placement');
          document.querySelector("#first-article").style.paddingTop ='100px';
        }
      }
      if(window.innerWidth <=600){
        if (scrollTop < prevState.scrollTop){
          if(document.getElementById('atFrame_SkinTop') !=null){
            document.getElementById('atFrame_SkinTop').style.top ='73px';
            document.getElementById('atFrame_SkinRight').style.top ='73px';
          }

        }else{
          if(document.getElementById('atFrame_SkinTop') !=null){
            document.getElementById('atFrame_SkinTop').style.top ='30px';
            document.getElementById('atFrame_SkinRight').style.top ='30px';

          }

        }
      }

      return newState;
    });
  }

  onSearchCloseClick () {
    const searchElement = document.getElementById('nav-search');
    if (searchElement instanceof Element) { searchElement.classList.remove("open"); }
  }

  onMagnifierClick () {
    const searchElement = document.getElementById('nav-search');
    if (searchElement instanceof Element) {
      searchElement.classList.toggle("open");
      const searchInput = searchElement.getElementsByClassName("search-input")[0];
      if (searchInput instanceof HTMLInputElement) { searchInput.focus(); }
    }
  }

  onBurgerClick () {
    const menuElement = document.getElementById('menu-nav');
    if (menuElement instanceof Element) { menuElement.classList.toggle("open"); }
  }

  getCategoryName () {
    const {catName} = this.props;
    /**
     * Specifically handling the case of 'hot topics' and 'fashion & beauty'
     */
    return catName.replace(/ /g, '-').replace('&', 'and');
  }

  getOnTop () {
    const {scrollTop} = this.state;
    if (document.getElementsByClassName('superbanner__inner').length === 0) {
      return scrollTop === 0;
    } else if (window.innerWidth <= 1039) {
      return scrollTop <= window.innerHeight;
    } else if (window.innerHeight / window.innerWidth >= .5625) {
      return scrollTop <= window.innerWidth * .5625;
    }
    return scrollTop <= window.innerHeight;
  }

  renderThemeLogo () {
    const {theme} = this.props;
    if (typeof theme === 'string') {
      if (theme.includes('shemom')) { return (<img src="/assets-2021/img/nav-shemom-logo-2021.svg" />); }
      if (theme.includes('brides')) { return (<img src="/assets-2021/img/nav-shebrides-logo-2021.svg" />); }
      // And other themes' logos here
    }
    return (<img src="/assets-2021/img/nav-she-logo-2021.svg" />);
  }

  renderChannelTitle () {
    const catName = this.getCategoryName();
    const {catName: catTitle, catSlug, theme} = this.props;
    const logo = getChannelLogo(theme, catSlug);

    if (logo === null) { return null; }

    if (logo === '') {
      return (
        <div className="nav__channel-title nav__channel-title--text">
          <a href={`/${catSlug}`}>{catTitle}</a>
        </div>
      );
    }

    return (
      <div className="nav__channel-title">
        <a href={`/${catName}`}>
          <img src={logo} />
        </a>
      </div>
    );
  }

  render () {
    const {page, catSlug, theme, pageId} = this.props;
    const {scrollTop, scrollingUp, hitTop} = this.state;
    const onTop = this.getOnTop();
    //534764 is mirror page ID
    //402399 is xmas facelift page id
    const noHiding = !['home', 'category'].includes(page)&&!['534764','541649'].includes(pageId);

    const hide = scrollTop === 0 && !noHiding;
    const logo = getChannelLogo(theme, catSlug);


    return (
      <div
        ref={this.rootRef}
        className={classNames(
          "nav",
          typeof logo === 'string' ? `nav--${catSlug.replace(/ /g, '-')}` : 'nav--uncategorized',
          {
            "nav--on-top": onTop,
            "nav--no-hiding": noHiding,
            "nav--page-single": page === 'single',
            "nav--scrolling-up": scrollingUp,
            "nav--hit-top": hitTop,
          }
        )}
      >
        <div className="nav__bar">
          <div className="nav__channel-stript" />
          <a className="nav__logo" href="/">{this.renderThemeLogo()}</a>
          {this.renderChannelTitle()}
        </div>
        <div className="nav__inner">
          <i className="nav__search icon-search-01" onClick={this.onMagnifierClick} />
          <i className="nav__burger icon-menu-01" onClick={this.onBurgerClick} />
        </div>
      </div>
    );
  }
}

Nav.propTypes = {
  theme: PropTypes.string.isRequired,
  catName: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/Nav.js